/**
 * PDF Service
 *
 * Angular 10 Upgrade - Modified by Mihir
 * Date: May 7, 2026
 *
 * Changes Made:
 * - Fixed import statement for HttpService (line 3)
 * - Changed from type-only import to regular import
 *
 * BEFORE (Angular 9):
 * import type { HttpService } from '../httpservice/http.service';
 *
 * AFTER (Angular 10):
 * import { HttpRequestModel, HttpService } from '../httpservice/http.service';
 *
 * Reason for Change:
 * TypeScript 4.0 (required by Angular 10) has stricter rules for type-only imports.
 * Classes used in dependency injection cannot use 'import type' syntax.
 * This was causing compilation error: NG2003 - No suitable injection token.
 */

import { Injectable } from '@angular/core';
import { HttpRequestModel, HttpService } from '../httpservice/http.service';

@Injectable({
  providedIn: 'root',
})
export class PdfService {
  DEFAULT_FONT_SIZE = 10;
  DEFAULT_PAGE_NUMBER = 1;
  DEFAULT_TEXT_COLOR = 150;

  HttpRequestModel: HttpRequestModel = new HttpRequestModel();

  constructor(private httpService: HttpService) {}

  public async saveToPdf(filename: string, content: object, type: 'invoice' | 'jobDetail') {
    try {
      const serializedBody = {
        content,
        filename,
        options: {
          defaults: {
            fontSize: this.DEFAULT_FONT_SIZE,
            pageNumber: this.DEFAULT_PAGE_NUMBER,
            textColor: this.DEFAULT_TEXT_COLOR,
          },
        },
      };

      this.HttpRequestModel.reset();
      this.HttpRequestModel.method = 'POST';
      this.HttpRequestModel.url = `generatePdf/${type}`;
      this.HttpRequestModel.body = serializedBody;
      this.HttpRequestModel.responseType = 'blob';

      return this.httpService.init(this.HttpRequestModel).subscribe(res => {
        // SUPER HACKY
        const anchor = document.createElement('a');
        document.body.appendChild(anchor);
        anchor.style.display = 'none';

        const fileURL = URL.createObjectURL(res);

        anchor.href = fileURL;
        anchor.download = filename;
        anchor.click();
        window.URL.revokeObjectURL(fileURL);
      });
    } catch (error) {
      console.error('SAVE TO PDF ERROR:', error);
    }
  }
}
